import type { FaireProductEntity } from "../../entity_types/product";

export const p_2dwde3z5nd: FaireProductEntity = {
  token: "p_2dwde3z5nd",
  type: "product",
  name: "Tis The Season T-Shirt (Grey) - Youth",
  brandToken: "b_1105vh61su",
  brandName: "Baseballism",
  imageUrl:
    "https://cdn.faire.com/fastly/d52f6e81eefa866b5477290beef9f836887f557c73118af697297483daee4474.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ce097954999575ca9979e476eeb3f0923f57bcb0e46450e35f4e7e6d60a5a8c.jpeg",
    "https://cdn.faire.com/fastly/0e806db1bbcd9a5348225a69b05745aa89604140dc70ecc7c4f976363c5098f5.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "EVERYBODY WAKE UP BASEBALL SEASON IS ABOUT TO START!!!\n\nDiamond Fabric Standard Tee - Features:\n\n * Regular fit: Size up for a relaxed fit \n * 185gsm medium weight fabric: Strikes the perfect balance between comfort and durability. \n * Custom Baseballism artwork: Unique, exclusive designs that showcase your love for the game. \n * 50/50 poly-cotton blend: Combines softness and durability with Baseballism's signature Diamond Fabric for a premium feel. \n * Four-way stretch: Provides enhanced mobility and comfort, ideal for everyday wear. \nCare: Machine wash cold water - Tumble dry low heat\n\nHOW TO MEASURE, ALL MEASUREMENTS IN INCHES\nChest: Measure across the fullest part of your chest, armpit to armpit\nLength: Top of the shirt to the bottom \n\n",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:30.990Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
